import script from "./MobileWarning.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileWarning.vue?vue&type=script&lang=ts&setup=true"

import "./MobileWarning.vue?vue&type=style&index=0&id=4b8115fb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b8115fb"]])

export default __exports__